define('WidgetInstanceModel',['jquery','underscore','LocalStorage','ObjectModel','app',
    'models/ProductModel',
    'sprintf'
],function ($,_,LocalStorage,ObjectModel,app,
     ProductModel,
     sprintf
) {
    //
    // Model WidgetInstance
    //
    var WidgetInstanceModelPrototype = {

        name:'WidgetInstanceModel',
        route:'apiWidgetInstanceModel',
        idAttribute:'id_widget_instance',

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            this.setup();
        },
        setup:function(){},
        getClassName:function(){return this.get('widget_class_name')},
        getTemplate:function(){

            var t = this.p('template');
            return t ? t : 'default';
        },
        getParam:function(key){
            var v = this.get('params')[key];
            return v;
        },
        getTitle:function () {
            var t = this.get('name');
            return t ;
        },
        isMobile:function(){
            return app.isMobile();
        },
        getConfig: function(param){
            return app.c(param);
        },
        getOption:function(key){
            var o = this.get('options');
            if(o && o[key]) return o[key];
        },
        p:function(k){return this.getParam(k)},
        // escape widget param as html attribute
        pattr:function(k){return (this.getParam(k)||'').replace(/'/g, "&#39;").replace(/"/g, "&#34;")},
        psprintf:function(k,options){
            return sprintf.vsprintf(this.p(k),options);
        },
        is:function(k){return this.p(k) == true},
        getImgUrl:function(id_picture,suffix,format,rewrite){
            return app.getPictureUrl(id_picture,'Widget',suffix, format, rewrite);
        },
        getParamImgUrl:function(k,suffix,format,rewrite){
            return this.getImgUrl(this.p(k),suffix,format,rewrite);
        },
        prepareDatas:function(){
            // noop
        }
    };

    var WidgetInstanceModel = ObjectModel.extend(LocalStorage).extend(WidgetInstanceModelPrototype);

    return WidgetInstanceModel;
});
